import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { IEmployeeState } from "models/Slices/employeeSlice.model";
import { employeeAsync } from "redux/actions/Employee.action";
import { IEmployeeProfileResponse } from "models/Employee/employeeProfile.model";

const initialState: IEmployeeState = {
  employee: null,
  loading: false,
  error: "",
  success: false,
};

export const employeeSlice = createSlice({
  name: "employee",
  initialState,
  reducers: {
    resetEmployee: () => initialState,
    resetEmployeeError: (state) => {
      state.error = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(employeeAsync.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        employeeAsync.fulfilled,
        (state, action: PayloadAction<IEmployeeProfileResponse>) => {
          state.loading = false;
          state.employee = action.payload;
          state.success = !state.employee?.ErrorCode ? true : false;
        }
      )
      .addCase(employeeAsync.rejected, (state, action: any) => {
        state.loading = false;
        state.error = action.error?.message;
        state.success = false;
      });
  },
});

export const { resetEmployee, resetEmployeeError } = employeeSlice.actions;

export const selectSuccess = (state: RootState) => state.employee.success;
export const selectEmployee = (state: RootState) => state.employee.employee;

export default employeeSlice.reducer;
